/* ============================================================
   HERZ DER KARTEN – product-page.js
   Alle Produktseiten-Events zentral hier verwaltet.
   ============================================================ */

// i18n-Bruecke: aus layout/theme.liquid injiziert (window.themeStrings / window.routes).
// Bewusst ZUWEISUNG statt const-Deklaration: alle Theme-Skripte teilen sich den globalen
// Scope, eine zweite `const T` wuerde einen SyntaxError werfen und die Datei stilllegen.
// Die Fallbacks halten die Datei lauffaehig, falls das Layout die Injection nicht liefert.
window.themeStrings = window.themeStrings || {};
window.routes = window.routes || {};

// #product-json (main-product.liquid) einmal parsen und cachen — wird von der
// Varianten-Logik UND dem "Zuletzt angesehen"-Modul gebraucht (frueher 2x geparst).
// ACHTUNG: seit dem Audit PERF-3 (2026-08-29) ist das KEIN vollstaendiges
// Produktobjekt mehr, sondern ein handgeschriebenes Minimal-JSON (handle, options,
// variants mit id/title/option1-3/price/compare_at_price/available/
// selling_plan_allocations). Wer ein weiteres Feld braucht, ergaenzt es dort.
let hdkProductJson;
function readProductJson() {
  if (hdkProductJson === undefined) {
    try { hdkProductJson = JSON.parse(document.getElementById('product-json')?.textContent); }
    catch (e) { hdkProductJson = null; }
  }
  return hdkProductJson;
}


document.addEventListener('DOMContentLoaded', () => {

  // ----------------------------------------------------------
  // Bildergalerie – Thumbnail-Wechsel & Varianten-Filterung
  // ----------------------------------------------------------
  // Galerie = Track aus Slides (2026-08-07). #gallery-main-img ist nur noch ein
  // unsichtbarer Anker, der die alte Schnittstelle "welches Medium ist aktiv"
  // bedient (Lightbox/Zoom lesen dort dataset.index); die Anzeige steuert der Track.
  const mainImg    = document.getElementById('gallery-main-img');
  const galTrack   = document.getElementById('gallery-track');
  const galSlides  = Array.from(document.querySelectorAll('.product-gallery__slide'));
  const allThumbs  = Array.from(document.querySelectorAll('.product-gallery__thumb'));

  // Bilder werden NICHT alle geladen: nur das aktive Medium und je ein Nachbar
  // bekommen ihre src (dieses Produkt hat 31 Medien / 1.17 MB, gemessen 2026-08-07).
  // Das Startmedium traegt seine src bereits serverseitig (LCP).
  // Laden UND dekodieren: Ein Bild kann fertig geladen, aber noch nicht dekodiert
  // sein — dann zeigt der Slide beim Hineinwischen kurz den Containergrund. decode()
  // zieht die Dekodierung vor; fetchPriority hebt die Nachbarbilder aus der
  // Lazy-Warteschlange (auf DPR-3-Geraeten laedt der Browser die 1200w-Variante,
  // ~40-70 KB je Bild — gemessen 2026-08-07).
  function ladeSlideBild(slide) {
    if (!slide) return;
    const img = slide.querySelector('.product-gallery__slide-img');
    if (!img || img.getAttribute('src')) return;
    img.loading = 'eager';
    if ('fetchPriority' in img) img.fetchPriority = 'high';
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    if (img.decode) img.decode().catch(function () {});
  }
  // Die Wisch-Geste (assets/product-gallery.js) zieht das Ziel-Bild vor,
  // sobald die Richtung feststeht — noch waehrend der Finger unterwegs ist.
  window.__galerieSlideLaden = ladeSlideBild;
  // Zweistufig (Cyre 2026-08-07): Sofort das aktive Medium und seine direkten
  // Nachbarn — dann nach dem load-Event der Rest der sichtbaren. Nur ±1 reichte
  // beim schnellen Durchblaettern nicht: das dritte Bild war noch nicht da und
  // man sah kurz den Containergrund mit Alt-Text.
  //
  // Deckel 3 (Audit PERF-2, 2026-08-29). Die urspruengliche 8 war am 2026-08-07
  // auf ein 31-Medien-Produkt kalibriert, bei dem der Varianten-Filter ~3 Slides
  // uebrig liess — der Deckel griff dort faktisch nie. Seit dem Standard-Case
  // (46 Medien, viele filterneutrale Herstellerbilder) schoepft er voll aus:
  // gemessen 9 Galerie-Derivate à bis 82 KB im Ladefenster. 3 deckt genau den
  // Zweck ab (aktives Bild + die beiden Nachbarn stehen bereit); ±1 ist ohnehin
  // schon sofort geladen, alles Weitere holt der Vorzieher der Wisch-Geste
  // waehrend des Fingers nach.
  const VORLADE_DECKEL = 3;
  let restVorgeladen = false;
  function ladeFenster(idx) {
    const sichtbar = galSlides.filter(s => s.style.display !== 'none');
    const pos = sichtbar.findIndex(s => s.dataset.index === String(idx));
    if (pos === -1) { ladeSlideBild(galSlides[idx]); return; }
    [pos - 1, pos, pos + 1].forEach(i => {
      if (i >= 0 && i < sichtbar.length) ladeSlideBild(sichtbar[i]);
    });
    if (restVorgeladen) return;
    restVorgeladen = true;
    // Nach dem load-Event statt im Leerlauf: requestIdleCallback kam mit seinem
    // 2500ms-Fenster zu spaet, wer sofort schnell durchblaetterte sah das dritte
    // Bild noch nicht (Cyre 2026-08-07). Nach load ist der LCP-Pfad durch, die
    // Nachbarbilder konkurrieren also mit nichts mehr.
    // Die sichtbare Liste wird ERST IM CALLBACK ermittelt: Beim Init sind noch alle
    // Medien sichtbar (der Varianten-Filter laeuft danach) — mit der Liste von jetzt
    // haette der Vorlader 8 statt 3 Bilder gezogen (gemessen: 10 Galerie-Requests).
    const rest = () => galSlides
      .filter(s => s.style.display !== 'none')
      .slice(0, VORLADE_DECKEL)
      .forEach(ladeSlideBild);
    if (document.readyState === 'complete') rest();
    else window.addEventListener('load', rest, { once: true });
  }

  // Track auf die Position des Mediums schieben. animiert=false beim Init und beim
  // Varianten-Filter — dort darf nichts sichtbar rutschen.
  function trackZuIndex(idx, animiert) {
    if (!galTrack) return;
    const sichtbar = galSlides.filter(s => s.style.display !== 'none');
    const pos = Math.max(0, sichtbar.findIndex(s => s.dataset.index === String(idx)));
    // Dauer/Easing aus der geteilten Gesten-Konfiguration (Inline-Script in
    // main-product.liquid, laeuft vor diesem deferred Asset) — Fallback haelt die
    // Datei eigenstaendig lauffaehig.
    const g = window.__hdkGeste || { ZU_INDEX_MS: 320, EASING: 'cubic-bezier(0.22, 0.72, 0.24, 1)' };
    galTrack.style.transition = animiert ? 'transform ' + g.ZU_INDEX_MS + 'ms ' + g.EASING : 'none';
    galTrack.style.transform = 'translateX(' + (-pos * 100) + '%)';
    galTrack.dataset.index = idx;
    if (mainImg) mainImg.dataset.index = idx;
    ladeFenster(idx);
  }

  function setActiveThumb(thumb, animiert) {
    allThumbs.forEach(t => t.classList.remove('product-gallery__thumb--active'));
    thumb.classList.add('product-gallery__thumb--active');
    const idx = thumb.dataset.index;
    const isImage = thumb.dataset.mediaType === 'image';

    // Video im Slide starten/pausieren. Inaktive Videos liegen in <template>
    // (Poster-Defer, s. main-product.liquid) und werden erst hier instanziiert.
    galSlides.forEach(s => {
      const box = s.querySelector('.product-gallery__slide-media');
      if (!box) return;
      const on = !isImage && s.dataset.index === idx;
      // Das <template> bleibt stehen (frueher: tpl.remove()) — nur so laesst sich ein
      // Fremdvideo beim Verlassen des Slides wieder abraeumen und spaeter neu bauen.
      // Fremdvideos (iframe im Template) laufen zusaetzlich durch das Consent-Gate
      // aus dem Inline-Script (window.__hdkVideoConsent, SEC-1 2026-08-29): ohne
      // Marketing-Consent erscheint eine Klick-zum-Laden-Flaeche statt des iframes.
      // Fallback ohne Gate (Inline-Script nicht geladen): altes Verhalten — die
      // Datei bleibt eigenstaendig lauffaehig (s. Kommentar bei __hdkGeste).
      const tpl = box.querySelector('template[data-deferred-media]');
      if (on && tpl && !box.querySelector('video, iframe, .video-consent')) {
        const inhalt = tpl.content.cloneNode(true);
        const vc = window.__hdkVideoConsent;
        if (inhalt.querySelector('iframe') && vc && !vc.erlaubt()) {
          const m = (window.__hdkImages || [])[Number(s.dataset.index)] || {};
          box.appendChild(vc.gate(m, () => tpl.content.cloneNode(true)));
        } else {
          box.appendChild(inhalt);
        }
      }

      // Fremdvideo (YouTube/Vimeo) laeuft im iframe und kennt keine pause()-API:
      // gestoppt wird es, indem der iframe beim Verlassen aus dem DOM faellt. Ohne
      // <template> (Startmedium, direkt gerendert) bleibt nur das Neuladen der src.
      const f = box.querySelector('iframe');
      if (f) {
        if (!on) {
          if (tpl) f.remove();
          // Startmedium (direkt gerendert, kein <template>): nur das Neuladen der src
          // stoppt es. Das darf pro Verlassen genau EINMAL feuern (CQ-7, 2026-08-29) —
          // vorher lud jeder weitere Slide-Wechsel den laengst stehenden Player erneut.
          else if (!f.dataset.hdkGestoppt) { f.dataset.hdkGestoppt = '1'; f.src = f.src; }
        } else {
          delete f.dataset.hdkGestoppt;
        }
      }

      const v = box.querySelector('video');
      if (!v) return;
      if (on) {
        v.loop = false;
        try { v.currentTime = 0; } catch (e) {}
        const p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });

    trackZuIndex(idx, animiert !== false);
  }

  allThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => setActiveThumb(thumb));
  });

  // Scroll-Signal der Thumb-Leiste: Kantenfade-Klassen (CSS-Mask) nur dort setzen,
  // wo tatsaechlich verdeckte Thumbs liegen. Thumbs sind fix 60px gross, daher ist
  // die Scroll-Ausdehnung unabhaengig vom Bild-Ladezustand stabil. Die Leiste liegt
  // je nach Layout horizontal (mobil, Mengenrabatt) oder vertikal (Desktop-Spalte)
  // — die aktive Achse verraet flex-direction.
  const thumbStrip = document.querySelector('.product-gallery__thumbs');
  function thumbAxisVertical() {
    return getComputedStyle(thumbStrip).flexDirection === 'column';
  }
  function syncThumbFades() {
    if (!thumbStrip) return;
    const vertical = thumbAxisVertical();
    const pos = vertical ? thumbStrip.scrollTop : thumbStrip.scrollLeft;
    const max = vertical
      ? thumbStrip.scrollHeight - thumbStrip.clientHeight
      : thumbStrip.scrollWidth - thumbStrip.clientWidth;
    thumbStrip.classList.toggle('has-scroll-start', pos > 1);
    thumbStrip.classList.toggle('has-scroll-end', pos < max - 1);
  }
  if (thumbStrip) {
    thumbStrip.addEventListener('scroll', syncThumbFades, { passive: true });
    window.addEventListener('resize', syncThumbFades);
    syncThumbFades();

    // Maus-Drag: geteilte Mechanik window.hdkDragScroll (theme.js), achsenbewusst —
    // die Achse folgt beim pointerdown der flex-direction (Desktop-Spalte vertikal).
    // Klick nach echtem Drag unterdrueckt, sonst wechselte beim Loslassen das Hauptbild.
    window.hdkDragScroll(thumbStrip, { achse: () => (thumbAxisVertical() ? 'y' : 'x') });
  }

  // Slides an den Thumb-Zustand koppeln: nicht passende Slides fallen per display:none
  // aus dem Flex-Fluss, damit die sichtbaren luecklos nebeneinander liegen und ihre
  // Track-Position ihrer Position unter den sichtbaren Medien entspricht. Ihre Bilder
  // bleiben dadurch ungeladen (data-src) — der Filter ist zugleich die Ladebremse.
  function syncSlidesMitThumbs() {
    const erlaubt = new Set(
      allThumbs.filter(t => t.style.display !== 'none').map(t => t.dataset.index)
    );
    galSlides.forEach(s => {
      s.style.display = erlaubt.has(s.dataset.index) ? '' : 'none';
    });
    // Andere Variante = andere sichtbare Slides -> Vorladen erneut zulassen
    restVorgeladen = false;
  }

  function filterGallery(variantTitle) {
    if (!variantTitle || variantTitle === 'Default Title') {
      allThumbs.forEach(t => t.style.display = '');
      syncSlidesMitThumbs();
      if (allThumbs.length > 0) setActiveThumb(allThumbs[0], false);
      syncThumbFades();
      return;
    }
    const variantLower = variantTitle.toLowerCase();
    let visibleThumbs = [];
    allThumbs.forEach(thumb => {
      // data-alt = roher Media-Alt aus dem Liquid (main-product.liquid Thumbs):
      // das DOM-alt traegt einen a11y-Fallback auf den Produkttitel und ist als
      // Filter-Signal unbrauchbar (2026-08-24). Der fruehere document.title-
      // Vergleich war doppelt tot: der Titel ist der SEO-Titel + Shop-Suffix.
      const alt = (thumb.dataset.alt || '').toLowerCase();
      const isGeneric = alt === '';
      // exakter Match: 'Blau' darf nicht 'Hellblau' treffen (Teilstring-includes war zu locker)
      const matchesVariant = alt === variantLower;
      if (isGeneric || matchesVariant) {
        thumb.style.display = '';
        visibleThumbs.push(thumb);
      } else {
        thumb.style.display = 'none';
      }
    });
    syncSlidesMitThumbs();
    const variantThumb = visibleThumbs.find(t =>
      (t.dataset.alt || '').toLowerCase() === variantLower
    );
    // Varianten-Wechsel springt ohne Animation (sonst rutscht der Track sichtbar)
    if (variantThumb) setActiveThumb(variantThumb, false);
    else if (visibleThumbs.length > 0) setActiveThumb(visibleThumbs[0], false);
    syncThumbFades();
  }

  // Startzustand: Slides passend zu den (noch ungefilterten) Thumbs, Track auf das
  // Startmedium — ohne Animation und ohne zusaetzliche Bild-Requests.
  if (galTrack) {
    syncSlidesMitThumbs();
    trackZuIndex(parseInt(galTrack.dataset.index, 10) || 0, false);
  }

  // ----------------------------------------------------------
  // Mengenauswahl + Inventory-Check
  // Event Delegation — EIN Handler, keine Duplikate möglich
  // ----------------------------------------------------------
  const qtyInput   = document.getElementById('quantity');
  const stockIndicator = document.getElementById('stock-indicator');
  const variantSel = document.getElementById('variant-select');

  function getCurrentVariantId() {
    if (variantSel) return parseInt(variantSel.value, 10);
    const hiddenId = document.querySelector('input[name="id"]');
    return hiddenId ? parseInt(hiddenId.value, 10) : null;
  }

  // Kaufbare Menge der gewaehlten Variante. Die Regel ist window.hdk.kaufbareMenge
  // (assets/hdk-util.js, unit-getestet) — dieselbe Funktion wie die GradedGuard-
  // Stepper (Audit 2026-10 ARCH-2): nicht kaufbar (variantAvailable false) -> 0;
  // ungetrackter Bestand/Ueberverkauf -> unbegrenzt; sonst Bestand minus Cart-Menge,
  // zusaetzlich gedeckelt durch die Max.-Bestellmenge (custom.max_bestellmenge,
  // produktweit) abzueglich Cart-Menge.
  function getMaxQty() {
    const id = getCurrentVariantId();
    return window.hdk.kaufbareMenge(
      window.variantInventory?.[id],
      window.cartQty?.[id] || 0,
      window.productMaxOrderQty,
      window.variantAvailable?.[id]
    );
  }

  function updateQtyUI() {
    if (!qtyInput) return;
    const max      = getMaxQty();
    // Gewählte Menge auf die kaufbare Menge runterclampen, wenn max unter den
    // Regler-Stand fällt (z.B. die Mengenwahl im Drawer erhöht die Cart-Menge, während
    // hier noch eine hohe Menge gewählt ist): der ATC-Submit schickt qtyInput roh —
    // und Shopify fängt die Bestandsüberschreitung hier NICHT ab: der ATC sendet das
    // Einzelformat {id, quantity}, das /cart/add.js am Dev-Server ohne Klemmung übernahm
    // (20 bei Bestand 14 -> HTTP 200; nur das items-Format antwortet mit 422 und
    // Teilmenge, Audit Warenkorb 26.10.2026 R-10). Das Bestellmengen-Limit fängt Shopify
    // ohnehin nicht. /cart/update.js nimmt jede Menge an (deshalb klemmt die Mengenwahl
    // im Warenkorb die getippte Menge selbst).
    if (isFinite(max) && max > 0 && parseInt(qtyInput.value, 10) > max) {
      qtyInput.value = max;
    }
    const val      = parseInt(qtyInput.value, 10);
    const noStock  = isFinite(max) && max <= 0;

    // Max.-Bestellmenge-Zeile nur bei verfuegbarem Artikel zeigen (Cyre 2026-08-30):
    // bei «Nicht verfuegbar» ist die Info sinnlos und wirkt wie ein Widerspruch.
    const maxOrderLine = document.getElementById('max-order-line');
    if (maxOrderLine) {
      maxOrderLine.hidden = window.variantAvailable?.[getCurrentVariantId()] === false;
    }
    const atMax    = noStock || (isFinite(max) && val >= max);

    const qtyPlus  = document.getElementById('qty-plus');
    const qtyMinus = document.getElementById('qty-minus');
    if (qtyPlus)  qtyPlus.disabled  = atMax;
    if (qtyMinus) qtyMinus.disabled = val <= 1;

    // Hinzufügen-Button (ATC normal ODER Vorbestellung): Verfügbarkeit vor Restmenge prüfen.
    // Während des Hinzufügens (dataset.loading) den Button nicht anfassen.
    const addBtn = atcBtn || preorderBtn;
    if (addBtn && !addBtn.dataset.loading) {
      const id           = getCurrentVariantId();
      const unavailable  = window.variantAvailable?.[id] === false;
      const defaultLabel = window.productIsPreorder ? window.themeStrings.preorderNow : window.themeStrings.addToCart;
      let label;
      if (unavailable) {
        addBtn.disabled = true;
        label = window.themeStrings.unavailable;
      } else if (noStock) {
        addBtn.disabled = true;
        label = window.themeStrings.maxQtyReached;
      } else {
        addBtn.disabled = false;
        label = defaultLabel;
      }
      addBtn.textContent = label;
      // Statusspiegel fuer Screenreader (aria-live, WCAG 4.1.3): der Button selbst
      // taugt nicht als Live-Region — sein disabled-Wechsel wirft ihn aus dem
      // Tab-Fluss und macht das Vorlesen unzuverlaessig. Nur bei echter Aenderung
      // schreiben, sonst wiederholt jeder Mengen-Klick dieselbe Ansage.
      const atcStatus = document.getElementById('atc-status');
      if (atcStatus && atcStatus.textContent !== label) atcStatus.textContent = label;
    }

    // variantAvailable ist die Kauf-Wahrheit (Tracking + Policy + Bestand) — wie beim ATC-Gate.
    // inventory_quantity liefert nur die Stueckzahl; verfuegbar mit stock <= 0 = ungetrackt/
    // Ueberverkauf erlaubt -> gruen "Verfuegbar" statt faelschlich rot.
    if (stockIndicator && !window.productIsPreorder) {
      const id        = getCurrentVariantId();
      const stock     = window.variantInventory?.[id];
      const available = window.variantAvailable?.[id];
      const incoming  = window.variantIncoming?.[id] === true;
      const inStock   = typeof stock === 'number' && stock > 0;
      let stockHtml;
      // Zweite Zeile «Erwarteter Wareneingang» nur im amber-Zustand, sonst leer (CSS :empty)
      let incomingDateText = '';
      if (incoming && !inStock) {
        // Netto-Bestand <= 0, aber eingehender Bestand -> beim Lieferanten nachbestellt.
        // Datum (variant.next_incoming_date) ist optional: fehlt es, keine zweite Zeile.
        const date = window.variantIncomingDate?.[id];
        stockHtml = '<span class="stock-dot stock-dot--amber"></span>' + window.themeStrings.incoming;
        if (typeof date === 'string' && date !== '') {
          incomingDateText = window.themeStrings.incomingDate.replace('__D__', date);
        }
      } else if (available === false) {
        stockHtml = '<span class="stock-dot stock-dot--red"></span>' + window.themeStrings.unavailable;
      } else if (inStock) {
        // Knappheit sichtbar machen (Cyre 2026-08-09): unter 6 Stueck "Nur N Stueck an Lager".
        // Schwellen 10/6 = window.hdk.lagerText (assets/hdk-util.js), geteilt mit gradedguard.js.
        const lagerKey = window.hdk.lagerText(stock);
        const label = lagerKey === 'stockMoreThan'
          ? window.themeStrings.stockMoreThan
          : window.themeStrings[lagerKey].replace('__N__', stock);
        stockHtml = '<span class="stock-dot stock-dot--green"></span>' + label;
      } else if (available === true) {
        stockHtml = '<span class="stock-dot stock-dot--green"></span>' + window.themeStrings.available;
      } else {
        stockHtml = '';
      }
      // Nur bei echter Aenderung schreiben: das Element ist eine aria-live-Region —
      // identisches Neu-Setzen wuerde Screenreadern bei jedem Mengen-Klick
      // denselben Bestand erneut ansagen.
      if (stockIndicator.innerHTML !== stockHtml) stockIndicator.innerHTML = stockHtml;
      // innerHTML-Quelle ist eigenes Markup: Locale-String `_html` mit dem Datum im
      // .delivery-when-Span (Akzent wie das Zeitwort der Lieferzeile, Cyre 2026-09-14),
      // das Datum selbst kommt formatiert aus Liquid — gleiches Muster wie die Lieferzeile.
      const incomingDateEl = document.getElementById('incoming-date');
      if (incomingDateEl && incomingDateEl.innerHTML !== incomingDateText) incomingDateEl.innerHTML = incomingDateText;
    }

    updateDeliveryEstimate();
  }

  // ----------------------------------------------------------
  // Liefertermin-Schaetzung («bis 15 Uhr bestellt, morgen geliefert»)
  // Laeuft bewusst im Browser, nicht in Liquid: Shopify cacht Storefront-HTML
  // im CDN — eine servergerenderte Uhrzeit waere beliebig veraltet. Zeitbasis
  // ist fix Europe/Zurich (das Versprechen gilt nach Shop-Zeit, nicht nach der
  // Geraete-Zeitzone des Besuchers).
  // Regelwerk: Versandtag = heute, wenn Werktag und vor 15:00 Zuerich, sonst
  // naechster Werktag; Liefertag = naechster Werktag nach dem Versandtag.
  // Rechner, Bestellschluss und Feiertagsliste liegen seit 2026-10-17 in
  // assets/hdk-util.js (hdk.lieferAussage, LIEFER_CUTOFF_STUNDE, LIEFER_FEIERTAGE) —
  // der Verfuegbarkeits-Tooltip der Produktkarte (theme.js) zeigt dieselbe Aussage.
  // Bestellschluss-/Tarifaenderungen: Checkliste docs/betrieb.md §13 (alle Fundstellen).
  // ----------------------------------------------------------
  const deliveryMain = document.getElementById('delivery-estimate');

  function updateDeliveryEstimate() {
    if (!deliveryMain) return;
    const deliverySticky = document.getElementById('sticky-atc-delivery');
    const str = window.themeStrings;
    // innerHTML-Quelle ist eigenes, vertrauenswuerdiges Markup (stock-dot + Text) —
    // gleiches Muster wie der Lager-Indikator. Der gruene Punkt sitzt auf der
    // Lieferzeile; die Lager-Zeile darunter verliert ihren per CSS-Geschwister-
    // Selektor (product-page.css, «Ein-Block-Layout»). Leere Lieferzeile = die
    // Lager-Zeile traegt ihren Punkt selbst — gilt auch im Countdown-Modus.
    // Text-Teil in EINEM Span: die Zeilen sind display:flex — nackte Textknoten wuerden
    // zu eigenen Flex-Items und das Leerzeichen zwischen Span und Text fiele weg
    // («Morgengeliefert»); im Span bleibt der normale Inline-Fluss erhalten.
    const line = (text) => text === '' ? '' : '<span class="stock-dot stock-dot--green"></span><span>' + text + '</span>';
    const render = (text, stickyHtml) => {
      deliveryMain.innerHTML = line(text);
      if (deliverySticky) {
        const s = stickyHtml === undefined ? line(text) : stickyHtml;
        deliverySticky.innerHTML = s;
        deliverySticky.hidden = s === '';
      }
    };

    // Nur fuer kaufbare Lager-Varianten — dieselbe Wahrheit wie der gruene Stock-Dot
    const id = getCurrentVariantId();
    const stock = window.variantInventory?.[id];
    const available = window.variantAvailable?.[id];
    const incoming = window.variantIncoming?.[id] === true;
    const inStock = typeof stock === 'number' && stock > 0;
    const deliverable = !window.productIsPreorder && !(incoming && !inStock)
      && available !== false && (inStock || available === true);
    if (!deliverable) { render(''); return; }

    // Regel + Wortlaut = window.hdk.lieferAussage (assets/hdk-util.js, unit-getestet
    // inkl. Kalender-Ablauf-Test): Zuercher Kalenderzeit, Cutoff, Wochenende,
    // Feiertage; Aussage («wann kommt das Paket?») bewusst OHNE Countdown (Cyre
    // 2026-08-03, C2-Panel gebaut und wieder verworfen): vor der Bestellkante
    // «Morgen geliefert», danach «Übermorgen …» bzw. «Mo, 10.8. geliefert».
    const lang = document.documentElement.lang || 'de';
    const statement = window.hdk.lieferAussage(new Date(), lang, str).text;
    // Sticky-ATC: der Lagerbestand haengt als Suffix-Span an der Zeile — Mobile zeigt
    // ihn komma-getrennt inline, Desktop blendet das Suffix per CSS aus und zeigt
    // stattdessen die Lager-Zeile darunter (Produktseiten-Zweizeiler; die 280px-Karte
    // traegt die Langform nicht einzeilig). Ohne bekannte Stueckzahl (ungetracktes
    // Inventar) nur die Aussage — «, Verfuegbar» daneben waere redundant.
    let stickyHtml = line(statement);
    if (inStock) {
      const stockShort = window.hdk.lagerText(stock) === 'stockMoreThan'
        ? str.stockMoreThanShort
        : str.stockCountShort.replace('__N__', stock);
      // &nbsp; statt Leerzeichen: das Suffix ist ein eigenes Flex-Item — ein fuehrendes
      // normales Leerzeichen wuerde am Zeilenanfang kollabieren («,mehr als …»)
      stickyHtml += '<span class="sticky-atc__delivery-stock">,&nbsp;' + stockShort + '</span>';
    }
    render(statement, stickyHtml);
  }

  // Die Aussage kippt nur an der Bestellkante/Mitternacht — Minutenraster genuegt;
  // bei Tab-Rueckkehr sofort neu rechnen (Kante kann ueberschritten worden sein)
  setInterval(updateDeliveryEstimate, 30000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateDeliveryEstimate();
  });

  // Event Delegation — ein einziger Handler für alle qty-Buttons
  if (!window.__qtyDelegationActive) {
    window.__qtyDelegationActive = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quantity-selector__btn');
      if (!btn || !qtyInput) return;
      const val = parseInt(qtyInput.value, 10);
      if (btn.id === 'qty-plus') {
        const max = getMaxQty();
        if (!isFinite(max) || val < max) {
          qtyInput.value = val + 1;
          updateQtyUI();
        }
      } else if (btn.id === 'qty-minus') {
        if (val > 1) {
          qtyInput.value = val - 1;
          updateQtyUI();
        }
      }
    });
  }

  // Cart-Mengen laden und UI initialisieren
  function applyCartQty(cart) {
    window.cartQty = {};
    cart.items.forEach(item => {
      window.cartQty[item.variant_id] = (window.cartQty[item.variant_id] || 0) + item.quantity;
    });
    updateQtyUI();
  }

  // Cart aus event.detail nutzen, wenn vorhanden (spart /cart.js); sonst fetchen.
  function loadCartQty(cart) {
    if (cart && cart.items) { applyCartQty(cart); return Promise.resolve(); }
    // Summary ohne items (nach Add): cartQty wurde optimistisch aktualisiert -> nur UI refreshen
    if (cart) { updateQtyUI(); return Promise.resolve(); }
    // res.ok- und Typ-Guard (ROB-5, 2026-08-29): Shopify antwortet auf /cart.js im
    // Fehlerfall mit einer HTML- oder Fehler-JSON-Seite. Ohne Guards lief die dann
    // in applyCartQty (cart.items ist undefined -> TypeError, cartQty bleibt leer)
    // bzw. weiter unten in die Versandrechnung, wo aus undefined «CHF NaN» wurde.
    // Muster: assets/filter.js (:94). Der catch faellt auf reines UI-Refresh zurueck.
    return fetch(window.routes.cartJs)
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(c => {
        if (!c || !Array.isArray(c.items)) throw new Error('cart.js ohne items');
        applyCartQty(c);
      })
      .catch(() => updateQtyUI());
  }

  // Initialer Aufruf: KEIN eigener Fetch mehr — der gemeinsame /cart.js-Fetch unten
  // (bei updateShippingProgress) reicht den Cart an loadCartQty durch (H5, 2026-09-03).

  // Nach Cart-Aenderungen cartQty neu laden (Cart kommt via event.detail, kein Fetch)
  document.addEventListener('cart:updated', (e) => loadCartQty(e.detail));

  // ----------------------------------------------------------
  // Shipping Progress
  // ----------------------------------------------------------
  const shippingProgressEl = document.getElementById('shipping-progress');
  // Grenze aus dem Theme-Setting (data-Attribut, in Rappen). Fallback 6900 = CHF 69.
  const FREE_SHIPPING_THRESHOLD = parseInt(shippingProgressEl?.dataset.freeShippingThreshold, 10) || 6900;
  const shippingTextEl = document.getElementById('shipping-progress-text');
  const shippingFillEl = document.getElementById('shipping-progress-fill');
  const shippingPctEl = document.getElementById('shipping-progress-pct');

  function renderShippingProgress(cart) {
    if (!shippingTextEl) return;
    // Rohwert fuer Spiegel-UIs (Sticky-ATC) — die bauen daraus ihren eigenen Kurztext
    shippingTextEl.dataset.total = cart.total_price;
    // Regel = window.hdk.versandStand (assets/hdk-util.js, unit-getestet): Fuellstand,
    // In-Bar-Text und Erfolgszustand — dieselbe Funktion wie die Sticky-Leiste unten
    // und gradedguard.js; der Liquid-Zwilling fuer Drawer und /cart ist das Snippet
    // shipping-progress.liquid (SYNC-Marker versand-stand). Der Prozentwert steuert die
    // Textfarben-Kante (background-clip:text, theme.css), gezeigt wird der absolute
    // Stand «CHF 45.20 / 69.00» (Cyre 2026-09-12); ab der Grenze Kurztext
    // «Versandkostenfrei» + Modifier --erreicht (Haken, Schimmer, Puls).
    const st = window.hdk.versandStand(cart.total_price, FREE_SHIPPING_THRESHOLD, window.themeStrings.shippingFreeShort);
    if (shippingFillEl) {
      shippingFillEl.style.width = st.pct + '%';
    }
    if (shippingPctEl) {
      shippingPctEl.style.setProperty('--ship-pct', st.pct + '%');
      shippingPctEl.textContent = st.text;
    }
    shippingProgressEl.classList.toggle('shipping-progress--erreicht', st.erreicht);
    if (st.erreicht) {
      shippingTextEl.innerHTML = window.themeStrings.shippingFree;
    } else {
      // Das geschuetzte Leerzeichen aus chfAusRappen ist Absicht: «CHF 12.40» darf
      // mitten im Satz nicht umbrechen.
      shippingTextEl.innerHTML = window.themeStrings.shippingRemaining
        .replace('__AMOUNT__', window.hdk.chfAusRappen(st.rest));
    }
  }

  // Nutzt den Cart aus dem cart:updated-Event (event.detail) und spart so einen /cart.js-Roundtrip.
  // Ohne uebergebenen Cart (initialer Seitenaufruf) wird einmalig gefetcht.
  function updateShippingProgress(cart) {
    if (!shippingTextEl) return;
    if (cart && typeof cart.total_price === 'number') { renderShippingProgress(cart); return; }
    // res.ok + Typ-Guard wie in loadCartQty (ROB-5): total_price muss eine Zahl
    // sein, sonst rechnet renderShippingProgress mit undefined und schreibt
    // «CHF NaN» direkt neben den Kaufen-Knopf.
    fetch(window.routes.cartJs)
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(c => {
        if (!c || typeof c.total_price !== 'number') throw new Error('cart.js ohne total_price');
        renderShippingProgress(c);
      })
      .catch(() => {
        if (shippingTextEl) shippingTextEl.innerHTML = window.themeStrings.shippingFreeFrom.replace('__AMOUNT__', 'CHF\u00a0' + (FREE_SHIPPING_THRESHOLD / 100));
      });
  }

  // Initialer Seitenaufruf: EIN /cart.js-Fetch fuer Mengen (loadCartQty) UND
  // Versandfortschritt (updateShippingProgress). Bis 2026-09-03 holten beide den Cart
  // getrennt — zwei identische Requests bei DOMContentLoaded (Performance-Audit H5;
  // Dealeasy stellt einen dritten, der bleibt). Beide Funktionen nehmen den Cart als
  // Argument (derselbe Pfad wie beim cart:updated-Event); schlaegt der gemeinsame
  // Fetch fehl, laufen sie wie zuvor einzeln mit ihren eigenen Fallbacks.
  fetch(window.routes.cartJs)
    .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(c => {
      if (!c || !Array.isArray(c.items) || typeof c.total_price !== 'number') throw new Error('cart.js unvollstaendig');
      loadCartQty(c);
      updateShippingProgress(c);
    })
    .catch(() => { loadCartQty(); updateShippingProgress(); });
  document.addEventListener('cart:updated', (e) => updateShippingProgress(e.detail));

  // ----------------------------------------------------------
  // Varianten-Auswahl
  // ----------------------------------------------------------
  const variantBtns = document.querySelectorAll('.variant-btn');
  const priceWrap   = document.getElementById('price-wrap');
  const atcBtn      = document.getElementById('atc-btn');
  const preorderBtn = document.getElementById('preorder-btn');

  const productData = readProductJson();

  if (variantBtns.length && variantSel && productData) {
    const optionCount = productData.options.length;
    const selectedOptions = Array(optionCount).fill(null);

    variantBtns.forEach(btn => {
      if (btn.classList.contains('variant-btn--active')) {
        selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.value;
      }
    });

    const initialVariant = productData.variants.find(v =>
      selectedOptions.every((opt, i) => opt === null || v[`option${i + 1}`] === opt)
    );
    if (initialVariant) {
      filterGallery(initialVariant.title);
    }

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIndex, 10);
        selectedOptions[idx] = btn.dataset.value;

        // aria-pressed spiegelt die Auswahl fuer Screenreader (A11Y-1): die Buttons
        // sind das einzige Bedienelement, das Select ist nur Datentraeger.
        document.querySelectorAll(`.variant-btn[data-option-index="${idx}"]`).forEach(b => {
          const aktiv = b.dataset.value === btn.dataset.value;
          b.classList.toggle('variant-btn--active', aktiv);
          b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
        });

        // Farbe-Swatch: gewaehlten Farbnamen im Label anzeigen (Span existiert nur bei Farbe)
        const selName = btn.closest('.product-variants__group')?.querySelector('.product-variants__selected');
        if (selName) selName.textContent = ' · ' + (btn.getAttribute('aria-label') || btn.dataset.value);

        const match = productData.variants.find(v =>
          selectedOptions.every((opt, i) => opt === null || v[`option${i + 1}`] === opt)
        );

        if (match) {
          variantSel.value = match.id;
          filterGallery(match.title);

          if (priceWrap) {
            const price = (match.price / 100).toLocaleString('de-CH', { style: 'currency', currency: 'CHF' });
            const comparePrice = match.compare_at_price
              ? (match.compare_at_price / 100).toLocaleString('de-CH', { style: 'currency', currency: 'CHF' })
              : null;
            // Markup-Zwilling von main-product.liquid: Preis + Strichpreis als Gruppe, Pille daneben.
            const imSale = Boolean(comparePrice) && match.compare_at_price > match.price;
            let html = `<span class="product-info__price-group"><span class="product-info__price price">${price}</span>`;
            if (imSale) html += `<span class="product-info__compare-price">${comparePrice}</span>`;
            html += '</span>';
            if (imSale) {
              const savingsPct = Math.floor((match.compare_at_price - match.price) * 100 / match.compare_at_price);
              // Praefix-Span wie im Liquid-Zwilling (main-product.liquid): nur bei gefuelltem Locale-Key.
              const salePrefix = (window.themeStrings.salePrefix || '').trim();
              const prefixHtml = salePrefix ? `<span class="badge__prefix">${salePrefix}</span>` : '';
              html += `<span class="badge badge--sale">${prefixHtml}${window.themeStrings.youSave.replace('__PCT__', savingsPct)}</span>`;
            }
            priceWrap.innerHTML = html;
          }

          if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.unavailable;
          }

          // Qty auf 1 zurücksetzen + UI updaten
          if (qtyInput) qtyInput.value = 1;
          updateQtyUI();
        }
      });
    });
  }

  // ----------------------------------------------------------
  // In den Warenkorb / Vorbestellen (AJAX)
  // Geteilte Logik; der Vorbestell-Button hängt zusätzlich den Selling-Plan an,
  // damit STOQ die Position als echte Vorbestellung erkennt.
  // ----------------------------------------------------------
  function bindAddToCart(btn, { withSellingPlan = false } = {}) {
    if (!btn) return;
    const label = btn.textContent;
    btn.addEventListener('click', async () => {
      const variantId = variantSel?.value || document.querySelector('input[name="id"]')?.value;
      const quantity  = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!variantId) return;

      const body = { id: parseInt(variantId, 10), quantity };
      if (withSellingPlan) {
        let planId = null;
        if (productData) {
          const v = productData.variants.find(x => String(x.id) === String(variantId));
          planId = v?.selling_plan_allocations?.[0]?.selling_plan_id || null;
        }
        if (!planId) planId = btn.dataset.sellingPlan || null;
        if (planId) body.selling_plan = parseInt(planId, 10);
      }

      btn.disabled = true;
      btn.dataset.loading = '1';
      btn.textContent = window.themeStrings.adding;

      // Drawer SOFORT oeffnen (Panel + Spinner), unabhaengig vom Netz → instantes Feedback.
      if (window.CartDrawer?.openLoading) window.CartDrawer.openLoading();

      // Add ueber hdkCart.add (cart-drawer.js) im items-Format [{id, quantity[, selling_plan]}]
      // + Sections-Vertrag des Drawers, Erfolg -> onCartAdd (1 Roundtrip), 422/Netzfehler
      // -> Drawer offen mit Server-Stand und Kundentext aus hdkCart.addMeldung (Audit 2026-10-02
      // CQ-1/ROB-12, Owner-Entscheid 04.10.). items statt Einzelformat {id, quantity} seit
      // 27.10.2026 (Audit Warenkorb R-10): nur items klemmt Shopify auf den Bestand (422 mit
      // Teilmenge und Mengenmeldung); das Einzelformat buchte am Dev-Server 20 bei Bestand 14 mit
      // HTTP 200 — bei veraltetem Deckel (zweiter Tab, paralleler Kauf) eine Ueber-Bestand-Zeile
      // ohne Meldung. vorDrawer setzt die eigene Oberflaeche davor zurueck.
      await window.hdkCart.add([body], {
        vorDrawer: (ergebnis) => {
          delete btn.dataset.loading;
          btn.disabled = false;
          if (ergebnis.ok) {
            // cartQty optimistisch lokal aktualisieren (Server-Wahrheit folgt via cart:updated)
            window.cartQty = window.cartQty || {};
            const addedVariantId = parseInt(variantId, 10);
            window.cartQty[addedVariantId] = (window.cartQty[addedVariantId] || 0) + quantity;
            btn.textContent = label;
            if (qtyInput) qtyInput.value = 1;
            updateQtyUI();
          } else {
            // Teil-Einbuchung: cartQty (Basis der kaufbaren Menge) frisch aus /cart.js,
            // das cart:updated des Drawers traegt hier keine items. Die kurze Knopf-
            // Rueckmeldung bleibt zusaetzlich zum Drawer (Entscheid 2026-10-04 (2)).
            loadCartQty();
            btn.textContent = window.themeStrings.addError;
            setTimeout(() => { btn.textContent = label; }, 2500);
          }
        }
      });
    });
  }

  bindAddToCart(atcBtn);
  bindAddToCart(preorderBtn, { withSellingPlan: true });

  // ----------------------------------------------------------
  // Dealeasy Mengenrabatt-Bridge
  //  Die Stufen-Kacheln steuern UNSEREN Mengen-Regler (Dealeasys In-Kachel-Stepper
  //  ist per CSS ausgeblendet). Der Rabatt selbst laeuft serverseitig (Shopify
  //  Functions) nach Cart-Menge — wir setzen hier nur die Menge.
  //   - Klick auf Kachel -> #quantity = Mindestmenge der Stufe (geclamped auf die
  //     kaufbare Menge getMaxQty()).
  //   - Stufe, deren Mindestmenge die kaufbare Menge uebersteigt, wird ausgegraut +
  //     nicht klickbar (.dealeasy-tier-disabled) — sprengt sonst die Max-Bestellmenge.
  // ----------------------------------------------------------
  /* VENDOR:lb-root */
  const dealeasyRoot = document.getElementById('lb-vd-cards');
  if (dealeasyRoot && qtyInput) {
    const TIER = '.lb-qty-selector-tier-wrapper';

    /* VENDOR:lb-tier-minqty */
    // Mindestmenge = erste Zahl im Mengen-Text ("Kaufe 4 - 9" -> 4, "Kaufe 10+" -> 10);
    // sprachunabhaengig, kein Verlass auf Dealeasys (nur auf der aktiven Stufe vorhandenes) min-Attribut.
    //
    // Die AUSWERTUNG liegt seit 2026-09-02 in assets/hdk-util.js (Audit TEST-4),
    // hier bleibt nur die DOM-Abfrage. Grund: das ist der stillste Fehlerpfad der
    // ganzen Vendor-Kopplung — findet der Regex keine Zahl, gilt jede Stufe als
    // «ab 1 Stück», ohne jede Meldung (docs/vendor-kopplungen.md). Ausgelagert ist
    // sie ohne Browser gegen Randfaelle testbar (scripts/unit/hdk-util.test.js),
    // und scripts/vendor-smoke.js prueft am gerenderten DOM nachweislich DIESELBE
    // Funktion statt einer Kopie, die stillschweigend auseinanderlaufen kann.
    const tierMinQty = (tier) =>
      window.hdk.tierMinQty(tier.querySelector('.lb-qty-selector-quantity-text')?.textContent);

    // Der Stueckpreis-Zusatz haengt als nackter Textknoten NEBEN dem .money-Span
    // (<span class="…discounted-price-text"><span class="money">CHF 10.90</span> pro Stück</span>)
    // und wird auf den Locale-Text normalisiert — strukturbasiert (Knoten nach
    // .money) statt ueber den Wortlaut, also sprachunabhaengig. Aktuell decken sich
    // Locale und App-Wortlaut (DE "pro Stück", EN "each"), die Funktion ist damit
    // faktisch ein No-Op; sie bleibt als EINE Stellschraube, falls der Zusatz je
    // wieder gekuerzt werden soll (der Text ist in der Dealeasy-App nicht
    // konfigurierbar). Idempotent: schreibt nur bei Abweichung, die eigene
    // Mutation loest also keine weitere Runde aus.
    /* VENDOR:lb-perunit */
    const relabelPerUnit = () => {
      if (!window.themeStrings || !window.themeStrings.perUnit) return;
      const wanted = ' ' + window.themeStrings.perUnit;
      dealeasyRoot.querySelectorAll('.lb-qty-selector-discounted-price-text').forEach(price => {
        const money = price.querySelector('.money');
        let node = money && money.nextSibling;
        while (node && node.nodeType !== 3) node = node.nextSibling;
        if (node && node.textContent.trim() && node.textContent !== wanted) node.textContent = wanted;
      });
    };

    // Badge-Texte aus unseren Locales setzen (Cyre 2026-08-06). Grund: Dealeasys
    // Uebersetzungs-Blocks («default» / «de» / «en») greifen fuer die deutsche
    // Storefront nicht wie erwartet — Aenderungen landeten im «default»-Block,
    // ausgeliefert wird «de». Statt gegen die App-Datenhaltung zu arbeiten,
    // besitzen wir die zwei sichtbaren Strings selbst: zweisprachig, laengen-
    // kontrolliert (die Kachel ist ~108px breit) und an EINER Stelle pflegbar.
    // Emoji als eigenes Element, damit es kleiner gesetzt werden kann als der Text.
    // Klassenname bewusst OHNE "badge": unsere Reiter-Regel greift ueber
    // [class*="badge"] — ein Klassenname wie "tier-badge-emoji" wuerde von ihr
    // selbst erfasst und als zweiter Gold-Reiter gerendert (gemessen 2026-08-06).
    // Kein User-Input -> innerHTML unbedenklich; Strings kommen aus den Locales.
    const badgeHtml = (raw) => {
      const m = String(raw).match(/^(.*?)\s*([\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}])\s*$/u);
      return m
        ? m[1].replace(/[&<>]/g, '') + '<span class="tier-hl-emoji">' + m[2] + '</span>'
        : String(raw).replace(/[&<>]/g, '');
    };
    /* VENDOR:lb-badge-attr */
    const relabelBadges = () => {
      const s = window.themeStrings;
      if (!s || !s.tierBadgePopular) return;
      [
        ['[class*="popular-badge"]', s.tierBadgePopular],
        ['[class*="savings-badge"]', s.tierBadgeBest],
      ].forEach(([sel, text]) => {
        dealeasyRoot.querySelectorAll(sel).forEach(el => {
          const html = badgeHtml(text);
          if (el.innerHTML !== html) el.innerHTML = html;
        });
      });
    };

    // Stufen-Texte normalisieren (Cyre 2026-08-11), beides idempotent (schreibt nur
    // bei Abweichung -> keine MutationObserver-Schleife):
    //  1. Rabatt-Stufen zeigen "n+" statt Dealeasys Bereich "n - m" ("3 - 9 Stück"
    //     -> "3+ Stück"): die naechsthoehere Stufe rabattiert ja weiter, "ab n"
    //     ist also die einfachere Wahrheit. Die Standard-Stufe (kein Strichpreis-
    //     Element = kein Rabatt) behaelt ihren Bereich ("1 - 2 Stück").
    //  2. Ersparnis IMMER in Prozent: Dealeasy kann Rabatte auch als Festbetrag
    //     liefern ("CHF 2.00 Rabatt" / "Save CHF 2.00") — aus Strich- und Stueck-
    //     preis der Kachel wird der relative Rabatt berechnet und der ganze Text
    //     durch unseren Locale-String ersetzt (tierDiscountPct — spiegelt pro
    //     Sprache Dealeasys NATIVES Prozent-Wording "-5% Rabatt" / "Get 5% off",
    //     damit Festbetrag- und Prozent-Kampagnen identisch lesen). Native
    //     Prozent-Stufen enthalten keinen Betrag und bleiben komplett unberuehrt
    //     (ihren Wert NIE aus den gerundeten Preisen zurueckrechnen: 3.90 -> 3.71
    //     ergaebe 4.87% statt der konfigurierten 5%). Festbetraege werden
    //     ABGERUNDET — die Anzeige darf nie mehr versprechen, als der Rabatt
    //     hergibt.
    // Rein lokale DOM-Arbeit im selben Tick wie das Badge-Relabel: kein Netzwerk,
    // kein sichtbares Umspringen.
    /* VENDOR:lb-tier-money */
    // Betrags-Auswertung seit 2026-09-02 in assets/hdk-util.js (Audit TEST-4):
    // Schweizer Tausender-Apostroph (gerade UND typografisch), NBSP und Komma als
    // Dezimaltrenner — und NaN als GEWOLLTES Ergebnis, weil die Pruefung unten
    // (o > 0 && d >= 0 && d < o) damit sauber false wird und die Kachel
    // unberuehrt laesst statt sie falsch zu beschriften. Randfaelle sind in
    // scripts/unit/hdk-util.test.js festgehalten.
    const parseTierMoney = (el) => window.hdk.parseTierMoney(el?.textContent);
    const relabelTierTexts = () => {
      dealeasyRoot.querySelectorAll(TIER).forEach(tier => {
        const orig = tier.querySelector('.lb-qty-selector-original-price-text');
        if (!orig) return; // Standard-Stufe: nichts umschreiben
        const qtyEl = tier.querySelector('.lb-qty-selector-quantity-text');
        if (qtyEl) {
          const plus = qtyEl.textContent.replace(/(\d+)\s*[-–]\s*\d+/, '$1+');
          if (plus !== qtyEl.textContent) qtyEl.textContent = plus;
        }
        const discEl = tier.querySelector('.lb-qty-selector-discount-text');
        const pctString = window.themeStrings && window.themeStrings.tierDiscountPct;
        if (discEl && pctString && /CHF|Fr\./.test(discEl.textContent)) {
          const o = parseTierMoney(orig);
          const d = parseTierMoney(tier.querySelector('.lb-qty-selector-discounted-price-text .money'));
          if (o > 0 && d >= 0 && d < o) {
            const pct = Math.floor((1 - d / o) * 100);
            const next = pctString.replace('__PCT__', pct);
            if (next !== discEl.textContent) discEl.textContent = next;
          }
        }
      });
    };

    // Beim ersten Hydrieren einmalig die 1. Kachel (Standard-Stufe) vorauswaehlen
    // (Cyre 2026-08-18): die App kann nur RABATT-Stufen vorauswaehlen, die Standard-
    // Stufe nicht — deshalb uebernimmt das Theme die Vorauswahl. One-shot; entfaellt,
    // falls der Nutzer die Menge vorher schon selbst angefasst hat.
    let initialTierSynced = false;
    const sperreInitialSync = () => { initialTierSynced = true; };
    qtyInput.addEventListener('input', sperreInitialSync);
    document.querySelectorAll('.quantity-selector, .preorder-qty').forEach(el =>
      el.addEventListener('click', sperreInitialSync)
    );
    // Echte Nutzerklicks im Widget sperren die Vorauswahl ebenfalls — isTrusted
    // unterscheidet sie von unserem eigenen programmatischen first.click() unten.
    dealeasyRoot.addEventListener('click', (e) => { if (e.isTrusted) sperreInitialSync(); });
    // Tastatur-Bedienung (A11Y-2) ebenso — in der CAPTURE-Phase: Dealeasy setzt die
    // Auswahl in seinem eigenen Handler am <label>, und der MutationObserver kann
    // noch vor einem Bubble-Listener am Root laufen. Ohne Capture saehe syncAuswahl
    // den ersten Tastatur-Wechsel mit noch offener Vorauswahl und verwuerfe ihn.
    const AUSWAHL_TASTEN = [' ', 'Spacebar', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    dealeasyRoot.addEventListener('keydown', (e) => {
      if (e.isTrusted && AUSWAHL_TASTEN.includes(e.key)) sperreInitialSync();
    }, true);

    const decorateTiers = () => {
      relabelPerUnit();
      relabelBadges();
      relabelTierTexts();
      const tiers = dealeasyRoot.querySelectorAll(TIER);
      if (!tiers.length) return;
      if (!initialTierSynced) {
        // Programmatischer Klick statt Klassen-Setzen, damit der App-interne Zustand
        // (Radio, Preise) mitzieht; unser Klick-Handler unten stellt die Menge aufs
        // Stufen-Minimum (Standard-Stufe = 1). WICHTIG: Der Klick verpufft, solange
        // die Stencil-Komponente noch nicht interaktiv ist (Hydration) — deshalb wird
        // das Flag erst gesetzt, wenn die selected-Klasse nachweislich sitzt; bis
        // dahin klickt jeder Observer-Tick erneut (wirkungslose Klicks sind No-Ops,
        // echte Nutzerklicks sperren via isTrusted-Listener oben).
        const first = tiers[0];
        const maxKauf = getMaxQty();
        if (first.classList.contains('lb-qty-selector-tier-selected')) {
          initialTierSynced = true;
        } else if (isFinite(maxKauf) && tierMinQty(first) > maxKauf) {
          initialTierSynced = true; // ausverkauft/limitiert -> keine Vorauswahl erzwingen
        } else {
          // Klick auf den WRAPPER (Label), nicht aufs Radio: die Stencil-Komponente
          // fuehrt das Radio selbst (controlled) — ein programmatischer radio.click()
          // wird verworfen (empirisch geprueft 2026-08-18), der Label-Klick greift.
          first.click();
        }
      }
      const max = getMaxQty();
      let reenabledSelected = null;
      tiers.forEach(tier => {
        const wasDisabled  = tier.classList.contains('dealeasy-tier-disabled');
        const insufficient = isFinite(max) && tierMinQty(tier) > max;
        // toggle ohne echte Aenderung erzeugt keine Mutation -> kein MutationObserver-Loop
        tier.classList.toggle('dealeasy-tier-disabled', insufficient);
        // Gerade wieder freigegebene UND weiterhin ausgewaehlte Stufe merken
        if (wasDisabled && !insufficient && tier.classList.contains('lb-qty-selector-tier-selected')) {
          reenabledSelected = tier;
        }
      });
      // Wird die ausgewaehlte Stufe wieder kaufbar (z.B. Bestand im Cart freigegeben),
      // Menge auf ihr Minimum heben, falls der Regler noch darunter steht (z.B. auf 1).
      if (reenabledSelected) {
        const min = tierMinQty(reenabledSelected);
        const cur = parseInt(qtyInput.value, 10) || 1;
        if (min > cur) {
          qtyInput.value = isFinite(max) ? Math.min(min, max) : min;
          updateQtyUI();
        }
      }
    };

    // Menge = Stufen-Minimum, geklemmt auf die kaufbare Menge.
    const mengeAusStufe = (tier) => {
      const max = getMaxQty();
      const min = tierMinQty(tier);
      qtyInput.value = isFinite(max) ? Math.min(min, max) : min;
      updateQtyUI();
    };
    const istGewaehlt = (tier) =>
      tier.classList.contains('lb-qty-selector-tier-selected') || tier.getAttribute('aria-checked') === 'true';
    // Index der Stufe, deren Menge zuletzt in #quantity steht (-1 = noch keine).
    let synchronisierteStufe = -1;

    // Klick auf eine (kaufbare) Stufe -> unseren Mengen-Regler auf das Stufen-Minimum setzen
    dealeasyRoot.addEventListener('click', (e) => {
      const tier = e.target.closest(TIER);
      if (!tier || tier.classList.contains('dealeasy-tier-disabled')) return;
      synchronisierteStufe = Array.prototype.indexOf.call(dealeasyRoot.querySelectorAll(TIER), tier);
      mengeAusStufe(tier);
    });

    // Auswahl per TASTATUR (Audit 2026-10-02, A11Y-2): Dealeasys Kacheln sind
    // <label role="radio">; Pfeil verschiebt nur den Fokus, die Leertaste waehlt —
    // und loest dabei KEIN click aus (headless belegt 04.10.: nur die Klassen
    // `lb-qty-selector-tier-selected` und `aria-checked` wechseln). Der Klick-Handler
    // oben sah die Wahl deshalb nie, #quantity blieb auf 1. Darum wird hier der
    // Auswahl-ZUSTAND gelesen: wechselt die gewaehlte Stufe, folgt die Menge.
    // Vor dem ersten Nutzer-Eingriff (initialTierSynced false) wird der Wechsel nur
    // als Ausgangslage gemerkt — die Hydration darf eine vorher per +/- gesetzte
    // Menge nicht ueberschreiben, die Vorauswahl gehoert decorateTiers().
    const syncAuswahl = () => {
      const tiers = dealeasyRoot.querySelectorAll(TIER);
      const idx = Array.prototype.findIndex.call(tiers, istGewaehlt);
      if (idx === synchronisierteStufe) return;
      synchronisierteStufe = idx;
      if (idx < 0 || !initialTierSynced) return;
      if (tiers[idx].classList.contains('dealeasy-tier-disabled')) return;
      mengeAusStufe(tiers[idx]);
    };

    // Pfeiltasten WAEHLEN die Stufe (Abnahme Cyre 05.10.: «Stufen 2 & 3 per Tastatur
    // nicht auswaehlbar»). Belegt per echter Tab-Navigation: Dealeasy fuehrt eine
    // Radiogruppe mit rovingem tabindex (nur die gewaehlte Kachel ist Tab-Stopp —
    // aufgehoben durch tabStopps() unten), sein
    // keydown-Handler am <label> verschiebt bei Pfeiltasten aber nur den FOKUS — gewaehlt
    // wird erst mit Leertaste/Enter. Das WAI-ARIA-Muster der Radiogruppe (Pfeil = Fokus +
    // Auswahl) erwartet die Auswahl sofort; zusammen mit dem kaum sichtbaren Fokusring
    // wirkte die Staffel per Tastatur tot. Darum: nach Dealeasys Fokus-Wechsel (Bubble-
    // Phase am Root, plus setTimeout, falls er den Fokus asynchron setzt) die jetzt
    // fokussierte Kachel per Klick waehlen — derselbe Weg wie die Maus, die Menge folgt
    // ueber den Klick-Handler oben. Gesperrte Stufen bleiben fokussierbar, aber unwaehlbar.
    /* VENDOR:lb-tier-keys */
    const PFEILE = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    dealeasyRoot.addEventListener('keydown', (e) => {
      if (!e.isTrusted || !PFEILE.includes(e.key) || !e.target.closest(TIER)) return;
      setTimeout(() => {
        const tier = document.activeElement && document.activeElement.closest(TIER);
        if (!tier || !dealeasyRoot.contains(tier) || istGewaehlt(tier)) return;
        if (tier.classList.contains('dealeasy-tier-disabled')) return;
        tier.click();
      }, 0);
    });

    // JEDE kaufbare Kachel ist ein Tab-Stopp (Abnahme Cyre 05.10.: «per Tab nur die
    // 1. Kachel erreichbar»). Dealeasys Radiogruppe fuehrt einen rovingen tabindex:
    // beim Einfuegen alle Kacheln `-1`, danach bei JEDEM Auswahlwechsel die alte
    // gewaehlte `-1`, die neue `0` (headless belegt 05.10., Mutationslog) — zwischen
    // den Wechseln fasst er das Attribut nicht an. Darum: nach jeder Mutation alle
    // kaufbaren Kacheln auf `0` zuruecksetzen (der Observer unten beobachtet dafuer
    // auch `tabindex`). Gesperrte Stufen (.dealeasy-tier-disabled — Dealeasy selbst
    // markiert keine, unsere Klasse ist die einzige Sperre) verlassen die Tab-Folge
    // wie im WAI-ARIA-Muster der Radiogruppe und tragen `aria-disabled`; die Maus
    // sperrt `pointer-events: none`. Idempotent: geschrieben wird nur bei Abweichung,
    // die eigene Mutation loest also keine Schleife aus.
    /* VENDOR:lb-tier-tabindex */
    const tabStopps = () => {
      dealeasyRoot.querySelectorAll(TIER).forEach(tier => {
        const gesperrt = tier.classList.contains('dealeasy-tier-disabled');
        const soll = gesperrt ? '-1' : '0';
        if (tier.getAttribute('tabindex') !== soll) tier.setAttribute('tabindex', soll);
        if (gesperrt && tier.getAttribute('aria-disabled') !== 'true') tier.setAttribute('aria-disabled', 'true');
        if (!gesperrt && tier.hasAttribute('aria-disabled')) tier.removeAttribute('aria-disabled');
      });
    };
    // Leertaste/Enter waehlen bei Dealeasy OHNE Klick (Zugriffsart 5) — die Maus-
    // Sperre per pointer-events greift dort nicht. Erreicht der Fokus eine gesperrte
    // Kachel per Pfeil, blockt die Capture-Phase am Root die Wahl, bevor Dealeasys
    // Handler am <label> sie sieht.
    dealeasyRoot.addEventListener('keydown', (e) => {
      if (e.key !== ' ' && e.key !== 'Spacebar' && e.key !== 'Enter') return;
      const tier = e.target.closest && e.target.closest(TIER);
      if (!tier || !tier.classList.contains('dealeasy-tier-disabled')) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // Dealeasy hydriert/re-rendert das Widget client-seitig -> Deko nach jeder
    // childList-Mutation neu setzen; Attribut-Wechsel (Auswahl) -> Menge nachziehen.
    // Unsere eigenen Klassen-Toggles (dealeasy-tier-disabled) erzeugen ebenfalls
    // Attribut-Records — syncAuswahl ist dafuer ein No-op (Auswahl unveraendert).
    // Ein Re-Render (childList) setzt nur die Ausgangslage neu, ohne die Menge zu
    // aendern: so blieb es vor A11Y-2, und ein veralteter Index wuerde sonst den
    // naechsten echten Tastatur-Wechsel auf dieselbe Stufe verschlucken.
    // `tabindex` im Filter, damit tabStopps() Dealeasys rovingen Reset nach jedem
    // Auswahlwechsel sofort zuruecknimmt.
    new MutationObserver((records) => {
      if (records.some((r) => r.type === 'attributes')) syncAuswahl();
      if (records.some((r) => r.type === 'childList')) {
        decorateTiers();
        synchronisierteStufe = Array.prototype.findIndex.call(dealeasyRoot.querySelectorAll(TIER), istGewaehlt);
      }
      tabStopps();
    }).observe(dealeasyRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked', 'class', 'tabindex'] });
    decorateTiers();
    tabStopps();

    // Nachlauf fuer die Vorauswahl der 1. Kachel: der Observer sieht nur childList-
    // Mutationen — der Moment, in dem die Stencil-Komponente interaktiv wird
    // (hydrated-Klassenflip), erzeugt keine. Begrenzt getakteter Retry, bis die
    // Auswahl sitzt oder der Nutzer eingegriffen hat; nach 10s wird aufgegeben.
    const vorauswahlTimer = setInterval(() => {
      if (initialTierSynced) { clearInterval(vorauswahlTimer); return; }
      decorateTiers();
    }, 250);
    setTimeout(() => clearInterval(vorauswahlTimer), 10000);

    // Kaufbare Menge aendert sich bei Cart- oder Variantenwechsel -> Stufen neu bewerten
    document.addEventListener('cart:updated', decorateTiers);
    document.addEventListener('click', (e) => {
      if (e.target.closest('.variant-btn')) setTimeout(decorateTiers, 0);
    });
  }

  // ----------------------------------------------------------
  // Trust-Slider (Mobile, «Gold-Faden»-Design): Dots erzeugen + aktiven Dot live beim
  // Scrollen (rAF). Slides sind TEIL-breit (236px, naechste Station lugt hervor) ->
  // Index aus dem Slide-Schritt rechnen, nicht aus der Viewport-Breite; #trustbar-track
  // ist der Scroller-Wrapper, die Stationen liegen im __inner-Track darunter.
  // Desktop = statisches 4er-Raster (kein Scroll; Dots per CSS ausgeblendet).
  // ----------------------------------------------------------
  const trustTrack = document.getElementById('trustbar-track');
  const trustDots  = document.getElementById('trustbar-dots');
  const trustItems = trustTrack ? trustTrack.querySelectorAll('.trust-item') : [];
  if (trustTrack && trustDots && trustItems.length > 1) {
    // Dots als echte Buttons (klickbar auch auf kleinen Hover-Schirmen ohne Touch);
    // sichtbare Pille = Innen-Span, damit die Hit-Flaeche groesser sein kann.
    trustItems.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-trustbar__dotbtn';
      btn.setAttribute('aria-label', (window.themeStrings.sliderPosition || '__N__').replace('__N__', i + 1));
      const dot = document.createElement('span');
      dot.className = 'product-trustbar__dot' + (i === 0 ? ' product-trustbar__dot--active' : '');
      btn.appendChild(dot);
      trustDots.appendChild(btn);
    });
    const trustDotList = Array.from(trustDots.querySelectorAll('.product-trustbar__dot'));
    // Aktiv-Berechnung als benannte Funktion: laeuft im Scroll-Handler UND im
    // Settle-Watcher (iOS Safari feuert Scroll-Events nur waehrend der Finger zieht —
    // die Snap-Animation nach dem Loslassen ist STUMM, der Dot bliebe sonst auf dem
    // letzten Finger-Wert haengen; Cyre-Befund 2026-08-18).
    const trustIoModus = window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window;
    const updateTrustDots = () => {
      if (trustIoModus) return; // Touch: der IntersectionObserver unten ist die einzige Quelle
      const maxScroll = trustTrack.scrollWidth - trustTrack.clientWidth;
      const idx = maxScroll > 0
        ? Math.min(trustItems.length - 1, Math.max(0, Math.round((trustTrack.scrollLeft / maxScroll) * (trustItems.length - 1))))
        : 0;
      trustDotList.forEach((d, i) => d.classList.toggle('product-trustbar__dot--active', i === idx));
    };
    // Feste Nachlauf-Kette statt Stabilitaets-Abbruch: iOS aktualisiert scrollLeft
    // fuer JS waehrend der stummen Snap-Animation NICHT — ein "Wert unveraendert,
    // fertig"-Check bricht ab, bevor der finale Wert ankommt. Darum stur mehrere
    // Nachmessungen ueber ~1s; dazu scrollend (wo unterstuetzt) als Primaersignal.
    const TRUST_SETTLE_DELAYS = [120, 300, 600, 1000];
    let trustSettleTimers = [];
    const trustSettleStart = () => {
      trustSettleTimers.forEach(clearTimeout);
      trustSettleTimers = TRUST_SETTLE_DELAYS.map(ms => setTimeout(updateTrustDots, ms));
    };
    // Touch-Geraete: aktiver Dot via IntersectionObserver statt scrollLeft — iOS
    // Safari liefert scrollLeft bei composited Scrolling unzuverlaessig (stale
    // waehrend/nach der stummen Snap-Animation, Dot-Lag-Befund Cyre 2026-08-18);
    // der IO misst die TATSAECHLICHE Sichtbarkeit der Stationen im Scroller und
    // ist genau fuer diesen Fall gebaut. Aktiv = Station mit hoechstem
    // Sichtbarkeits-Anteil; bei Gleichstand gewinnt die bereits aktive.
    if (trustIoModus) {
      const ratios = new Map();
      let ioIdx = 0;
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => ratios.set(en.target, en.intersectionRatio));
        let bestIdx = 0, bestR = -1;
        trustItems.forEach((item, i) => {
          const r = ratios.get(item) || 0;
          if (r > bestR + 0.001) { bestR = r; bestIdx = i; }
          else if (Math.abs(r - bestR) <= 0.001 && i === ioIdx) { bestIdx = i; }
        });
        ioIdx = bestIdx;
        trustDotList.forEach((d, i) => d.classList.toggle('product-trustbar__dot--active', i === ioIdx));
      }, { root: trustTrack, threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
      trustItems.forEach(item => io.observe(item));
    }
    // Klick auf einen Dot -> proportionale Scroll-Position (0 -> Anfang, letzter ->
    // Maximum, dazwischen linear). Stations-zentrierte Ziele scheiterten auf breiten
    // Slider-Fenstern: Randstationen liegen dort ausserhalb der erreichbaren Mitte.
    trustDots.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-trustbar__dotbtn');
      if (!btn) return;
      const idx = Array.from(trustDots.children).indexOf(btn);
      const maxScroll = trustTrack.scrollWidth - trustTrack.clientWidth;
      if (maxScroll <= 0) return;
      trustTrack.scrollTo({ left: (idx / (trustItems.length - 1)) * maxScroll, behavior: 'smooth' });
    });
    // Maus-Drag: geteilte Mechanik window.hdkDragScroll (theme.js). Seit 2026-10-05
    // gibt auch dieser Streifen die Pointer-Capture beim Loslassen frei und
    // unterdrueckt den Klick nach einem echten Drag (vorher als einziger nicht).
    window.hdkDragScroll(trustTrack);
    let trustRaf = null;
    trustTrack.addEventListener('scroll', () => {
      trustSettleStart();
      if (trustRaf) return;
      trustRaf = requestAnimationFrame(() => {
        trustRaf = null;
        updateTrustDots();
      });
    }, { passive: true });
    // scrollend: feuert nach ABGESCHLOSSENER Snap-Animation (moderne Browser inkl.
    // aktuellem iOS Safari) — praezisestes Signal; die Nachlauf-Kette bleibt Fallback.
    trustTrack.addEventListener('scrollend', updateTrustDots);
    trustTrack.addEventListener('touchend', trustSettleStart, { passive: true });
  }

});
// ── Positions-Dots der Produkt-Streifen: window.initStripDots (brand-strip.js) ──
// Seit 15.10.2026 dort, geteilt mit dem Kundenstimmen-Karussell der Startseite;
// hier nur noch die Aufrufe nach dem Karten-Inject (brand-strip.js laedt vor dem
// ersten Aufruf: beide Skripte defer, die Aufrufe folgen auf einen fetch).

// ── Wisch-Hinweis der Produkt-Streifen (Geste-Plakette, Touch) ───────────────
// Seit 20.10.2026 hier statt in brand-strip.js (decisions 2026-10-20 (15)): der
// Code laeuft nur auf Produktseiten, brand-strip.js laedt aber auch auf der
// Startseite — dort kostete er 2.8 KB gzip ohne Nutzen. Exportiert als
// window.initStripHint, aufgerufen nach initStripDots fuer «Zuletzt angesehen»,
// «Ähnliche Artikel» und «Oft kombiniert mit» (Aufrufe weiter unten).
(function () {
  // Wisch-Hinweis (Touch-Geraete): blendet einmal pro Streifen und Seitenaufruf eine
  // Plakette ueber dem Streifen ein — Pfeil links, Hand, Pfeil rechts; die Hand wischt
  // einmal hin und her, dann blendet die Plakette aus und wird entfernt (Keyframes
  // .product-strip__hint*, product-page.css). Entscheid Cyre 20.10.2026 (docs/decisions.md
  // 2026-10-20 (11), loest den Track-Impuls (10) ab): seit die Produkt-Streifen mobil genau
  // zwei volle Karten zeigen, fehlt der Anschnitt als Scroll-Hinweis; die Punkte allein
  // sagen nicht «wischen». Markup hier statt in drei Section-Dateien: rein dekorativ
  // (aria-hidden, keine Texte, pointer-events: none), nur SVG-Striche — kein Locale-Key.
  // Bedingungen, alle noetig: Touch ohne Hover (Desktop hat Pfeile), kein reduced-motion,
  // echter Overflow, Streifen zu 60 % im Viewport und 400 ms spaeter immer noch (wer
  // vorbeiscrollt, sieht nichts), Nutzer hat den Streifen noch nicht gewischt. Nur eine
  // echte horizontale Bewegung des Streifens (scroll-Event des Viewports) bricht ab und
  // nimmt die Plakette sofort weg — ein Tippen oder Halten auf einer Karte laesst sie zu
  // Ende laufen (Cyre 20.10.: Fokus per Touch ist kein Wischen).
  // Kein scrollLeft, kein transform am Track: Punkte und Pfeile bleiben unberuehrt.
  // Buehne (.product-strip__hint-stage, 84x48 px): die Hand laeuft per CSS Motion Path
  // (offset-path) auf einem flachen Bogen von rechts nach links und zurueck; der
  // Schweif ist ein SVG-Pfad mit derselben Bogen-Geometrie, dessen sichtbares Stueck
  // per stroke-dashoffset hinter der Fingerspitze herzieht (pathLength="100", ein
  // Pfad je Richtung, drei gestapelte Striche abnehmender Laenge = Verjuengung).
  // Fingerspitzen-Bogen M62 22 Q40 8 18 22 (Apex 7 px ueber den Enden); der Hand-Pfad
  // in product-page.css ist derselbe Bogen um (+1.6, +9) versetzt, weil offset-path
  // die MITTE des 28-px-Icons fuehrt und die Spitze bei (12.4, 5) liegt.
  // Schweif-Fade (Cyre 20.10., «konstanter Fade statt drei Stufen»): je Richtung EIN
  // Strich, ausgeblendet durch eine SVG-Maske mit horizontalem Gradient (deckend an
  // der Spitze, nach hinten weich auslaufend); das Masken-Rechteck faehrt per CSS
  // mit dem Kopf mit (--hint-kopf-*, product-page.css). Die IDs der Masken sind pro
  // Plakette eindeutig (zwei Streifen koennen gleichzeitig im Bild sein; url(#id)
  // traefe sonst die Maske der anderen Plakette). Keyframes/Zeitplan: product-page.css
  // (Entscheide 2026-10-20 (13)/(14)).
  let hintZaehler = 0;
  const HINT_FADE_STOPS =
    '<stop offset="0" stop-color="#fff" stop-opacity="1"/>' +
    '<stop offset="0.35" stop-color="#fff" stop-opacity="0.7"/>' +
    '<stop offset="0.7" stop-color="#fff" stop-opacity="0.3"/>' +
    '<stop offset="1" stop-color="#fff" stop-opacity="0"/>';
  const HINT_MARKUP =
    '<svg class="product-strip__hint-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
    '<span class="product-strip__hint-stage">' +
      '<svg class="product-strip__hint-trails" viewBox="0 0 84 48" fill="none" stroke-linecap="round">' +
        '<defs>' +
          // Hinweg (Kopf laeuft nach links, Schweif rechts davon): deckend links -> transparent rechts
          '<linearGradient id="__ID__-fade-hin" x1="0" y1="0" x2="1" y2="0">' + HINT_FADE_STOPS + '</linearGradient>' +
          // Rueckweg (Kopf nach rechts, Schweif links): transparent links -> deckend rechts
          '<linearGradient id="__ID__-fade-zurueck" x1="1" y1="0" x2="0" y2="0">' + HINT_FADE_STOPS + '</linearGradient>' +
          '<mask id="__ID__-maske-hin" maskUnits="userSpaceOnUse" x="-40" y="0" width="164" height="48">' +
            '<rect class="product-strip__hint-fade product-strip__hint-fade--hin" x="62" y="0" width="30" height="48" fill="url(#__ID__-fade-hin)"/>' +
          '</mask>' +
          '<mask id="__ID__-maske-zurueck" maskUnits="userSpaceOnUse" x="-40" y="0" width="164" height="48">' +
            '<rect class="product-strip__hint-fade product-strip__hint-fade--zurueck" x="-12" y="0" width="30" height="48" fill="url(#__ID__-fade-zurueck)"/>' +
          '</mask>' +
        '</defs>' +
        '<g class="product-strip__hint-trail product-strip__hint-trail--hin" mask="url(#__ID__-maske-hin)">' +
          '<path class="product-strip__hint-seg product-strip__hint-seg--hin" d="M62 22Q40 8 18 22" pathLength="100"/>' +
        '</g>' +
        '<g class="product-strip__hint-trail product-strip__hint-trail--zurueck" mask="url(#__ID__-maske-zurueck)">' +
          '<path class="product-strip__hint-seg product-strip__hint-seg--zurueck" d="M18 22Q40 8 62 22" pathLength="100"/>' +
        '</g>' +
      '</svg>' +
      '<svg class="product-strip__hint-hand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M9 11.5V4.3a1.6 1.6 0 0 1 3.2 0v6.2"/>' +
        '<path d="M12.2 10.5a1.6 1.6 0 0 1 3.2 0v1.6"/>' +
        '<path d="M15.4 12.1a1.6 1.6 0 0 1 3.2 0v1.4"/>' +
        '<path d="M18.6 13.5a1.6 1.6 0 0 1 3.2 0v3.2a5.3 5.3 0 0 1-5.3 5.3h-3.6c-1.7 0-2.9-.6-3.9-1.6l-3.6-3.6a1.7 1.7 0 0 1 2.4-2.4L9 16.6"/>' +
      '</svg>' +
    '</span>' +
    '<svg class="product-strip__hint-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

  function initStripHint(root) {
    const viewport = root ? root.querySelector('[data-brand-viewport]') : null;
    const wrap = viewport ? viewport.parentElement : null; // .product-strip__viewport-wrap (position: relative)
    if (!viewport || !wrap || !('IntersectionObserver' in window)) return;
    if (root.dataset.hintArmed) return; // einmal pro Streifen, auch bei erneutem Init
    root.dataset.hintArmed = '1';
    if (!window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let hint = null;
    let abgebrochen = false;
    const entfernen = () => { if (hint) { hint.remove(); hint = null; } };
    const abbrechen = () => { abgebrochen = true; entfernen(); };
    // Nur der Viewport scrollt horizontal — sein scroll-Event IST die Wischbewegung.
    // Bewusst kein touchstart: Tippen/Halten auf einer Karte unterbricht nicht.
    viewport.addEventListener('scroll', abbrechen, { passive: true, once: true });

    const RUHE_MS = 400;
    const SICHTBAR = 0.6;
    const DAUER_MAX_MS = 3000; // Rueckfall, falls animationend ausbleibt (CSS-Weiche greift nicht)
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.unobserve(viewport);
      setTimeout(() => {
        if (abgebrochen) return;
        if (viewport.scrollWidth - viewport.clientWidth <= 1) return; // alles sichtbar
        // Nach der Ruhezeit nochmals messen: liegt der Streifen nicht mehr zu 60 % im
        // Fenster, war es ein Vorbeiscrollen — wieder scharf stellen statt feuern.
        const r = viewport.getBoundingClientRect();
        const sichtbar = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
        if (sichtbar < r.height * SICHTBAR) { io.observe(viewport); return; }
        hint = document.createElement('div');
        hint.className = 'product-strip__hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.innerHTML = HINT_MARKUP.replace(/__ID__/g, 'hdk-hint-' + (++hintZaehler)); // statisches Markup, keine Fremddaten
        hint.addEventListener('animationend', (e) => { if (e.target === hint) entfernen(); });
        wrap.appendChild(hint);
        setTimeout(entfernen, DAUER_MAX_MS);
      }, RUHE_MS);
    }, { threshold: SICHTBAR });
    io.observe(viewport);
  }
  window.initStripHint = initStripHint;
})();

// ── "Zuletzt angesehen" (localStorage-Historie + Section-Rendering) ──────────
// Tracking: jeder Produktseiten-Aufruf schreibt den Handle nach vorne (dedupe,
// Storage = aktuelles Produkt + 10 weitere/LRU, Verfall 7 Tage). Rendern: pro Handle die echte
// product-card via /products/<handle>?section_id=recently-viewed-card holen
// (Server-Liquid -> volle Karten-Paritaet inkl. Lager-Dot/Badges; /products/x.js
// als Alternative verworfen: liefert kein inventory_quantity). Lazy per
// IntersectionObserver auf dem 0-Pixel-Root; aktuelles Produkt gefiltert,
// sichtbar ab 1 Karte. Script laeuft deferred -> DOM steht.
(function () {
  var KEY = 'hdk-recently-viewed';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 Tage
  var STORE_LIMIT = 11; // aktuelles Produkt + 10 weitere (LRU: aeltestes faellt raus)
  var SHOW_LIMIT = 10;  // max sichtbare Karten (aktuelles Produkt ist gefiltert)

  var currentHandle = (readProductJson() || {}).handle || null;
  if (!currentHandle) return;

  function readList() {
    var now = Date.now();
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (en) { return en && en.h && now - (en.t || 0) < TTL_MS; });
    } catch (e) { return []; }
  }

  // Andere Produkte VOR dem Tracken merken (= Renderliste, aktuelles Produkt draussen)
  var others = readList().filter(function (en) { return en.h !== currentHandle; }).slice(0, SHOW_LIMIT);

  // 1) Tracken: aktuelles Produkt nach vorne, Cap schneidet das aelteste ab
  try {
    var updated = [{ h: currentHandle, t: Date.now() }].concat(others).slice(0, STORE_LIMIT);
    localStorage.setItem(KEY, JSON.stringify(updated));
  } catch (e) {}

  // 2) Rendern
  var root = document.getElementById('recently-viewed');
  var track = document.getElementById('recently-viewed-track');
  if (!root || !track || !others.length) return;

  var loaded = false;
  function loadCards() {
    if (loaded) return;
    loaded = true;
    // Karten ueber window.hdkKartenHolen (theme.js): holen, parsen, Badge-Text
    // lokalisieren, bevor die Karte ins DOM geht; 404/Fehler (geloescht,
    // unpubliziert) liefert null -> Karte still ueberspringen.
    Promise.all(others.map(function (en) {
      return window.hdkKartenHolen(window.routes.root + 'products/' + encodeURIComponent(en.h) + '?section_id=recently-viewed-card', '.product-card');
    })).then(function (karten) {
      var frag = document.createDocumentFragment();
      karten.forEach(function (card) {
        if (card) frag.appendChild(document.adoptNode(card));
      });
      if (!frag.childNodes.length) return;
      track.appendChild(frag);
      var inner = root.querySelector('.product-strip__inner');
      if (inner) inner.hidden = false;
      // Zweiter Durchgang auf dem eingehaengten Track: bewacht die Labels gegen
      // Judge.mes nachlaufende Pipeline (s. theme.js).
      if (typeof window.localizeReviewBadges === 'function') window.localizeReviewBadges(track, { watch: true });
      // Scroll-Mechanik (Pfeile/Drag) erst NACH dem Inject initialisieren -> misst echte Breiten
      if (typeof window.initBrandStrip === 'function') window.initBrandStrip(root);
      if (typeof window.initStripDots === 'function') window.initStripDots(root, document.getElementById('recently-viewed-dots'));
      // Wisch-Hinweis auf Touch-Geraeten (brand-strip.js, decisions 2026-10-20 (11))
      if (typeof window.initStripHint === 'function') window.initStripHint(root);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); loadCards(); return; }
      }
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else {
    loadCards();
  }
})();

// ── Empfehlungs-Streifen «Ähnliche Artikel» + «Oft kombiniert mit» ───────────
// Recommendations-API via Section-Rendering, Layout-Spiegel von "Zuletzt
// angesehen" (Cyre 2026-08-11): der Fetch laesst Shopify die Section serverseitig
// mit echten product-cards rendern, JS swappt das HTML und initialisiert danach
// Streifen (brand-strip.js) + Positions-Dots. Ersetzt das fruehere Inline-Script
// von «Ähnliche Artikel» (Autoplay-Karussell mit Klon-Loop) und seit 2026-10-20
// die Mechanik von «Oft kombiniert mit» (bis dahin Bundle-Selektor in
// assets/product-recommendations.js, docs/decisions.md 2026-10-20 (7)). Kein
// Lazy-Gate wie bei "Zuletzt angesehen": die Empfehlungen kommen ohnehin erst
// per Fetch, und der leere Container hat keine Hoehe.
(function () {
  // wurzel         Streifen-Root: traegt data-scroll-step und enthaelt nach dem
  //                Swap die data-brand-*-Anker
  // quellSelektor  Element der Antwort, dessen Inhalt in die Wurzel wandert
  // punkteId       ID des Dot-Containers — erst NACH dem Swap aufgeloest, weil er
  //                bei «Oft kombiniert mit» mit dem Swap erst ins DOM kommt
  // vorStart       optionaler Haken nach dem Swap, VOR der Streifen-Mechanik
  function empfehlungsStreifen(wurzel, url, quellSelektor, punkteId, vorStart) {
    // window.hdkKartenHolen (theme.js): holen, parsen, Review-Badges lokalisieren,
    // BEVOR die Karten ins DOM gehen; null bei Fehler.
    window.hdkKartenHolen(url, quellSelektor)
      .then((fresh) => {
        if (!fresh || fresh.children.length === 0) return; // keine Empfehlungen vorhanden

        wurzel.innerHTML = fresh.innerHTML;
        // Einblenden VOR dem Init: initBrandStrip/initStripDots messen Breiten, in
        // einem hidden-Vorfahren waeren sie 0 (kein Overflow -> keine Pfeile, keine Dots).
        if (vorStart) vorStart();

        // Zweiter Durchgang auf dem eingehaengten Container: bewacht die Labels
        // gegen Judge.mes nachlaufende Pipeline (s. theme.js).
        if (typeof window.localizeReviewBadges === 'function') window.localizeReviewBadges(wurzel, { watch: true });

        // Scroll-Mechanik erst NACH dem Swap (misst echte Breiten).
        if (typeof window.initBrandStrip === 'function') window.initBrandStrip(wurzel);
        if (typeof window.initStripDots === 'function') window.initStripDots(wurzel, document.getElementById(punkteId));
        // Wisch-Hinweis auf Touch-Geraeten (brand-strip.js, decisions 2026-10-20 (11))
        if (typeof window.initStripHint === 'function') window.initStripHint(wurzel);
      })
      .catch(() => {});
  }

  // «Ähnliche Artikel»: Wurzel und Antwort-Element sind die Section selbst.
  const verwandt = document.getElementById('related-products-section');
  if (verwandt && verwandt.dataset.recommendationsUrl) {
    empfehlungsStreifen(verwandt, verwandt.dataset.recommendationsUrl, '#related-products-section', 'related-products-dots');
  }

  // «Oft kombiniert mit»: Shell/Quelle-Split — der Kopf braucht product.title, das
  // es im Recommendations-Kontext nicht gibt. Die Quelle wandert in den Mount (der
  // Streifen-Root), die Shell bleibt hidden, bis Karten da sind.
  const shell = document.getElementById('product-recommendations-section');
  const mount = document.getElementById('product-recommendations-mount');
  const source = document.getElementById('product-recommendations-source');
  if (shell && mount && source && source.dataset.recommendationsUrl) {
    empfehlungsStreifen(mount, source.dataset.recommendationsUrl, '#product-recommendations-source', 'product-recommendations-dots', () => { shell.hidden = false; });
  }
})();

// ── Sticky-ATC (Desktop-Kaufkarte rechts / Mobile-Bottom-Bar) ────────────────
// Reines Spiegel-UI: keine eigene Kauf-Logik — Klicks werden an die echten
// Controls durchgereicht (#atc-btn/#preorder-btn, #qty-minus/#qty-plus), die
// Anzeige spiegelt Preis/Menge/Lager/Versand via MutationObserver. Dadurch
// erben alle States automatisch (Loading, Maximalmenge, Nicht verfuegbar,
// Vorbestellung, Dealeasy-Mengen-Bridge). Sichtbar erst, wenn die echte
// ATC-Zeile nach OBEN aus dem Viewport gescrollt ist (nicht schon, wenn sie
// beim Laden unter dem Fold liegt).
(function () {
  var sticky = document.getElementById('sticky-atc');
  if (!sticky) return;
  var mainBtn = document.getElementById('atc-btn') || document.getElementById('preorder-btn');
  // Ausloeser ist der ATC-Button selbst, nicht die .product-info__atc-wrap: die Wrap
  // traegt seit 2026-08-27 in einer zweiten Grid-Zeile die Shop-Bewertung — der Sticky
  // erschiene sonst erst, wenn auch die aus dem Viewport gescrollt ist.
  var anchor = mainBtn;
  var mainQty = document.getElementById('quantity');
  var mainMinus = document.getElementById('qty-minus');
  var mainPlus = document.getElementById('qty-plus');
  if (!mainBtn || !anchor || !mainQty || !mainMinus || !mainPlus) return;

  var sBtn = document.getElementById('sticky-atc-btn');
  var sPrice = document.getElementById('sticky-atc-price');
  var sQty = document.getElementById('sticky-atc-qty');
  var sMinus = document.getElementById('sticky-qty-minus');
  var sPlus = document.getElementById('sticky-qty-plus');
  var sStock = document.getElementById('sticky-atc-stock');
  var sShip = document.getElementById('sticky-atc-shipping');
  var sShipWrap = document.getElementById('sticky-atc-ship');
  var sShipFill = document.getElementById('sticky-atc-ship-fill');
  var mainPriceWrap = document.getElementById('price-wrap');
  var mainStock = document.getElementById('stock-indicator');
  var mainShip = document.getElementById('shipping-progress-text');
  var mainShipWrap = document.getElementById('shipping-progress');
  var shipThreshold = mainShipWrap ? (parseInt(mainShipWrap.dataset.freeShippingThreshold, 10) || 6900) : 6900;

  function syncQty() { sQty.textContent = mainQty.value; }
  function syncBtn() {
    sBtn.textContent = mainBtn.textContent.trim();
    sBtn.disabled = mainBtn.disabled;
  }
  function syncAll() {
    var p = mainPriceWrap ? mainPriceWrap.querySelector('.product-info__price') : null;
    if (p) sPrice.textContent = p.textContent.trim();
    // innerHTML-Spiegel: eigene, vertrauenswuerdige Markup-Quelle (stock-dot + Text)
    if (mainStock) sStock.innerHTML = mainStock.innerHTML;
    sStock.hidden = sStock.textContent.trim() === '';
    // Versand: Kurztext + Mini-Bar aus dem Rohwert des Haupt-Shipping-Progress
    // (dataset.total, gesetzt in renderShippingProgress) — nicht dessen Langtext spiegeln
    if (sShipWrap) {
      var totalRaw = mainShip ? mainShip.dataset.total : undefined;
      if (totalRaw === undefined) {
        sShipWrap.hidden = true;
      } else {
        var total = parseInt(totalRaw, 10) || 0;
        sShipWrap.hidden = false;
        // Dieselbe Regel wie die Haupt-Bar: window.hdk.versandStand. Unterhalb der
        // Grenze absoluter Stand «CHF 45.20 / 69.00», ab der Grenze Kurztext +
        // Erfolgs-Modifier (Haken, Schimmer, Puls); der Prozentwert steuert Mini-Bar
        // und Textfarben-Kante (background-clip:text im CSS).
        var st = window.hdk.versandStand(total, shipThreshold, window.themeStrings.shippingFreeShort);
        if (sShipFill) sShipFill.style.width = st.pct + '%';
        sShip.style.setProperty('--ship-pct', st.pct + '%');
        sShipWrap.classList.toggle('shipping-progress--erreicht', st.erreicht);
        sShip.textContent = st.text;
      }
    }
    syncQty();
    syncBtn();
  }

  // Proxy-Interaktionen: echte Controls klicken, Anzeige danach nachziehen
  sMinus.addEventListener('click', function () { mainMinus.click(); requestAnimationFrame(syncQty); });
  sPlus.addEventListener('click', function () { mainPlus.click(); requestAnimationFrame(syncQty); });
  sBtn.addEventListener('click', function () { mainBtn.click(); });

  // Spiegel aktuell halten: Button-States (inkl. Mengen-Reset nach erfolgreichem ATC,
  // erkennbar am Text-Flip), Preis/Lager/Versand bei Variantenwechsel und Cart-Updates
  var mo = new MutationObserver(syncAll);
  mo.observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-loading'] });
  if (mainPriceWrap) mo.observe(mainPriceWrap, { childList: true, characterData: true, subtree: true });
  if (mainStock) mo.observe(mainStock, { childList: true, characterData: true, subtree: true });
  if (mainShip) mo.observe(mainShip, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-total'] });

  var shown = false;
  var hideTimer = null;
  function syncPadding() {
    // Bar-Hoehe ist dynamisch (Stock-Zeile, Umbrueche) -> exakt messen statt Fixwert;
    // ein zu grosser Fixwert liess unter dem Footer ein Leerband in Hoehe der
    // Differenz mitscrollen (body-padding-bottom > reale Bar-Hoehe, nur Mobile)
    document.body.style.setProperty('--sticky-atc-h', sticky.offsetHeight + 'px');
  }
  function setShown(on) {
    if (on === shown) return;
    shown = on;
    if (on) {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      syncAll();
      sticky.hidden = false;
      syncPadding(); // messen erst nach hidden=false (vorher 0)
      document.body.classList.add('has-sticky-atc');
      requestAnimationFrame(function () { sticky.classList.add('is-shown'); });
    } else {
      // Slide-out: erst die Transition rauslaufen lassen (Transform zurueck an den
      // Rand), dann verstecken — hidden sofort wuerde den Effekt abwuergen
      sticky.classList.remove('is-shown');
      document.body.classList.remove('has-sticky-atc');
      hideTimer = setTimeout(function () {
        hideTimer = null;
        if (!shown) sticky.hidden = true;
      }, 350);
    }
  }
  // Wegklicken (X, nur Desktop sichtbar): gilt fuer die aktuelle Seitenansicht —
  // beim naechsten Produktaufruf erscheint die Karte wieder
  var dismissed = false;
  var closeBtn = document.getElementById('sticky-atc-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      setShown(false);
    });
  }

  new IntersectionObserver(function (entries) {
    var en = entries[entries.length - 1];
    setShown(!dismissed && !en.isIntersecting && en.boundingClientRect.top < 0);
  }, { threshold: 0 }).observe(anchor);
  window.addEventListener('resize', function () { if (shown) syncPadding(); });
})();

// ── Judge.me-Widget: Durchschnitts-Sterne im Kopf ────────────────────────────
// Der Minimal-Header des Review-Widgets zeigt nur Zahl + Zaehler ("5.0 · 3
// Bewertungen") — die Sterne ergaenzen wir selbst aus der gerenderten Zahl
// (CSS kann das nicht, statische Sterne waeren bei 4.x-Produkten falsch).
// Teil-Fuellung ueber Overlay-Breite in %; Styles: .hdk-avg-stars (CSS).
// Das Widget laedt async und rendert via Vue — wir haengen NUR ein eigenes
// Element an (fremde Nodes nie verschieben) und setzen es nach jedem
// Vue-Re-Render neu ein (MutationObserver, gleiches Muster wie Badge-Text).
(function () {
  var root = document.querySelector('.jdgm-review-widget');
  if (!root) return;

  function ensureStars() {
    var display = root.querySelector('.jm-average-rating-display--minimal-header .jm-cluster');
    if (!display || display.querySelector('.hdk-avg-stars')) return;
    var numEl = display.querySelector('.jm-text');
    var avg = parseFloat(numEl && numEl.textContent);
    if (!isFinite(avg)) return;
    var stars = document.createElement('span');
    stars.className = 'hdk-avg-stars';
    stars.setAttribute('aria-hidden', 'true'); // Zahl + Zaehler tragen die Information
    var base = document.createElement('span');
    base.className = 'hdk-avg-stars__base';
    base.textContent = '★★★★★';
    var fill = document.createElement('span');
    fill.className = 'hdk-avg-stars__fill';
    fill.style.width = (Math.max(0, Math.min(5, avg)) / 5 * 100) + '%';
    fill.textContent = '★★★★★';
    stars.appendChild(base);
    stars.appendChild(fill);
    numEl.after(stars);
  }

  // Datums-Trennzeichen: Judge.mes Format-Setting steuert nur die Reihenfolge
  // (TT/MM/JJJJ), nicht den Separator — Hauskonvention ist TT.MM.JJJJ. Regel =
  // window.hdk.jmDatum (assets/hdk-util.js), dieselbe wie reviews-page.js; sie
  // liefert null, wenn nichts umzuschreiben ist (der Observer feuert sonst im Kreis).
  /* VENDOR:jm-datum */
  function fixDates() {
    var texts = root.querySelectorAll('.jm-reviewer-info__details .jm-text');
    for (var i = 0; i < texts.length; i++) {
      var neu = window.hdk.jmDatum(texts[i].textContent);
      if (neu) texts[i].textContent = neu;
    }
  }

  // Kopf-Link des Widgets: Judge.me verlinkt Note/Sterne/Zaehler als <a target=_blank>
  // auf seine Reviews-Site (app.judge.me/reviews/stores/…). Cyre 16.10.2026: Ziel ist
  // unsere Bewertungsseite (window.routes.reviews, lokalisiert), im selben Tab, mit
  // eigenem aria-label. Nur schreiben, wenn etwas abweicht — der Observer feuert sonst
  // im Kreis. Fehlt die Seite (routes.reviews null), bleibt der Vendor-Link stehen.
  /* VENDOR:jm-header-link */
  function fixHeaderLink() {
    var ziel = window.routes && window.routes.reviews;
    var a = root.querySelector('a.jm-average-rating-display--minimal-header');
    if (!ziel || !a) return;
    if (a.getAttribute('href') !== ziel) a.setAttribute('href', ziel);
    if (a.hasAttribute('target')) a.removeAttribute('target');
    if (a.hasAttribute('rel')) a.removeAttribute('rel');
    var label = window.themeStrings && window.themeStrings.reviewsSeeAll;
    if (label && a.getAttribute('aria-label') !== label) a.setAttribute('aria-label', label);
  }

  function sync() { ensureStars(); fixDates(); fixHeaderLink(); }
  sync();
  new MutationObserver(sync).observe(root, { childList: true, subtree: true });
})();

/* ============================================================
   Verschoben 2026-09-02 aus main-product.liquid, Audit TEST-2

   Mehr/Weniger-Toggles (Beschreibung + Eigenschaften) und die
   messbasierte Kappung der Listen-Werte. Der Block stand als roher
   Skript-Block im Section-Markup, enthielt aber keine einzige
   Liquid-Ausgabe — er gehoerte damit nach assets/ (cachebar und vom
   CI-Gate scripts/theme-gates.js sichtbar).

   Zeitpunkt: frueher lief er beim Parsen der Section, jetzt per defer
   nach dem vollstaendigen Parsen des Dokuments (weiterhin vor
   DOMContentLoaded). Alle abgefragten Elemente stehen oberhalb der
   alten Blockposition, sind also in beiden Faellen da; die Messungen
   (scrollHeight / clientWidth) sind nach dem Parsen sogar verlaesslicher.
   ============================================================ */
(function () {
  // Mehr/Weniger-Toggles fuer Beschreibung und Eigenschaften (aria-expanded + Label-Tausch)
  document.querySelectorAll('.product-details__more').forEach(function (btn) {
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    btn.addEventListener('click', function () {
      // Beim EINklappen schrumpft die Seite ueber dem Viewport-Anker weg — den Button
      // an seiner Bildschirmposition festhalten, sonst "springt" der sichtbare Inhalt
      var yVorher = btn.getBoundingClientRect().top;
      var open = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
      btn.classList.toggle('is-open', open);
      // behavior:'instant' ueberstimmt das globale scroll-behavior:smooth — die
      // Korrektur muss ein unsichtbarer Sprung sein, kein sichtbares Gleiten
      if (!open) window.scrollBy({ top: btn.getBoundingClientRect().top - yVorher, behavior: 'instant' });
      fitListValues(); // aufgeklappte Listen-Zeilen (vorher display:none) jetzt einpassen
    });
  });
  // Beschreibung: Button nur zeigen, wenn der Text die Preview-Hoehe wirklich ueberragt
  // (kurze Texte stehen dann einfach komplett da). Nach fonts.ready erneut pruefen —
  // die Webfont-Metrik kann die Hoehe veraendern.
  var txt = document.getElementById('product-descr-text');
  var moreBtn = document.getElementById('product-descr-more');
  function syncDescrButton() {
    if (!txt || !moreBtn || txt.classList.contains('is-open')) return;
    var fits = txt.scrollHeight <= txt.clientHeight + 1;
    moreBtn.hidden = fits;
    txt.classList.toggle('is-short', fits);
  }
  syncDescrButton();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncDescrButton);
  window.addEventListener('resize', syncDescrButton);

  // Listen-Werte (Farbe/Kompatibilitaet/Sprache) flexibel kappen: so viele Eintraege,
  // wie in die Zeile passen, dann "+N weitere" — der Platz haengt von Viewport und
  // Labelbreite ab, darum messen (Canvas-Textbreite) statt fixer Wert-Anzahl.
  // Vollwert bleibt im title-Attribut. Funktions-DEKLARATION (hoisted): der
  // Toggle-Handler oben ruft sie beim Aufklappen der Specs erneut auf.
  function fitListValues() {
    var tpl = document.getElementById('product-specs-sheet');
    if (!tpl) return;
    var moreTpl = tpl.dataset.moreValues;
    var ctx = fitListValues._ctx || (fitListValues._ctx = document.createElement('canvas').getContext('2d'));
    document.querySelectorAll('.product-specs__value--list').forEach(function (dd) {
      if (!dd.dataset.items) dd.dataset.items = dd.textContent.trim();
      var row = dd.closest('.product-specs__row');
      if (!row || row.clientWidth === 0) return; // (noch) gekappte Zeile — kommt beim Aufklappen
      var items = dd.dataset.items.split(', ');
      var st = getComputedStyle(dd);
      ctx.font = st.fontWeight + ' ' + st.fontSize + ' ' + st.fontFamily;
      var labelW = row.querySelector('.product-specs__label').getBoundingClientRect().width;
      // Zeilenbreite minus Label, 2x gap (8px), Mindest-Punktleiter (28px), Sicherheitsmarge
      var avail = row.clientWidth - labelW - 16 - 28 - 8;
      var k = items.length;
      while (k > 1) {
        var cand = items.slice(0, k).join(', ') + (k < items.length ? ', ' + moreTpl.replace('__N__', items.length - k) : '');
        if (ctx.measureText(cand).width <= avail) break;
        k--;
      }
      dd.textContent = k < items.length
        ? items.slice(0, k).join(', ') + ', ' + moreTpl.replace('__N__', items.length - k)
        : dd.dataset.items;
    });
  }
  fitListValues();
  window.addEventListener('resize', fitListValues);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitListValues);
})();
